export default __webpack_public_path__ + "static/media/dining.d0796bcc.png";